var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPortfoliodetailsheader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1512,
    height: 323,
    viewBox: "0 0 1512 323",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M253.5 51.5H-4V0H1521V51.5H1202.5H1142.77C1100.48 51.5 1061.99 75.9054 1043.96 114.154L1033.45 136.443C979.76 250.331 865.16 323 739.25 323C613.102 323 498.973 248.161 448.69 132.468L440.731 114.154C424.196 76.1096 386.667 51.5 345.184 51.5H253.5Z",
    fill: "#E5EBF6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfoliodetailsheader);
export default __webpack_public_path__ + "static/media/portfoliodetailsheader.2bcd0ae2469b13537c9d1c7dfc51cd6d.svg";
export { ForwardRef as ReactComponent };